import { Select } from 'antd';
import { FC, memo, useEffect, useState } from 'react';
import { fetchRolesGroup } from 'services/api/roles';
import { RoleListRow } from 'types/api/roles';

interface IProps {
  value: string;
  onChange(value: string): void;
}

const RolesGroupSelect: FC<IProps> = ({ value, onChange }) => {
  const [results, setResults] = useState<RoleListRow[]>([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const rows = await fetchRolesGroup();
        if (cancelled) return;
        setResults(rows);
        const firstValue = rows[0]?.id;

        if (!value && firstValue != null) {
          onChange(String(firstValue));
        }
      } catch {
        // swallow — empty options on failure
      }
    };

    load();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Select
      options={results.map(item => ({
        label: item.name,
        value: String(item.id)
      }))}
      value={value}
      onChange={onChange}
    />
  );
};

export default memo(RolesGroupSelect);
